module.exports = __webpack_public_path__ + "static/media/2_square.b0082365.png";